import { render, staticRenderFns } from "./accuratePage.vue?vue&type=template&id=1c6c3eb9&scoped=true&"
import script from "./accuratePage.vue?vue&type=script&lang=js&"
export * from "./accuratePage.vue?vue&type=script&lang=js&"
import style0 from "./accuratePage.vue?vue&type=style&index=0&id=1c6c3eb9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6c3eb9",
  null
  
)

export default component.exports